import Vue from "vue";
import VTooltip from "v-tooltip";
import "./custom.scss";

Vue.use(VTooltip);
